// extracted by mini-css-extract-plugin
export default {"container":"textOnly_container__PsRoe","textOnlySec":"textOnly_textOnlySec__drBjL"};